<div #scrollContainer class="scroll-container">
  <ng-content></ng-content>
</div>

<div *ngIf="loading" class="loading-indicator">
  <img [src]="loadingGif" alt="">
  <p>{{ "community.infiniteScroll.loading" | translate }}</p>
</div>

<div class="all-post-loaded" *ngIf="!hasMore && (postsLength || post)">

  @if (listType === 'Comments') {
    <svg *ngIf="listType === 'Comments'">
        <use xlink:href="#allPostLoadedIcon"></use>
    </svg>

    <span>{{ "community.infiniteScroll.allCommentsLoaded" | translate }}</span>

  } @else if (listType === 'Members') {
    <svg *ngIf="listType === 'Members'">
      <use xlink:href="#allMemberLoadedIcon"></use>
    </svg>

    <span>{{ "community.infiniteScroll.allMembersLoaded" | translate }}</span>

  } @else if (listType === 'Notifications') {
    <svg *ngIf="listType === 'Notifications'">
      <use xlink:href="#allNotificationsLoadedIcon"></use>
    </svg>

    <span>{{ "community.infiniteScroll.allNotificationsLoaded" | translate }}</span>

  } @else {
    <svg *ngIf="listType === 'Posts'">
      <use xlink:href="#allPostLoadedIcon"></use>
    </svg>

    <span>{{ "community.infiniteScroll.allPostsLoaded" | translate }}</span>

  }

</div>
